import { InfoSet } from './InfoSet';

export default InfoSet;
